// Unit helpers — FR conventions. Speed shown in kt + km/h.
export const KT_TO_KMH = 1.852;
export const FUEL_DENSITY = 0.725; // kg/L AVGAS 100LL

export const ktToKmh = (kt) => (Number(kt) || 0) * KT_TO_KMH;

export const fmt = (v, d = 0) => {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return "—";
  return Number(v).toFixed(d);
};

// speed formatted as "110 kt · 204 km/h"
export const fmtSpeed = (kt) => `${fmt(kt, 0)} kt · ${fmt(ktToKmh(kt), 0)} km/h`;

export const fmtDeg = (v) => (v === null || v === undefined ? "—" : `${fmt(v, 0)}°`);

export const minToHm = (min) => {
  const m = Math.round(Number(min) || 0);
  const h = Math.floor(m / 60);
  const r = m % 60;
  return h > 0 ? `${h}h${String(r).padStart(2, "0")}` : `${r} min`;
};
